import apiNew from '../apiNew';

const fetchDash = (harvestId, customerId, farmId, str) => {
  return apiNew.get(`/dashboard`, {
    params: {harvestId: harvestId,
      customerId: customerId,
      farmId: farmId},
  });
};

export {fetchDash};
